import TextField from '@mui/material/TextField';
import { useState } from 'react';
import globals from '../../globals';


const EditCourseTF = ({numRows, rowsMax, onChange, idName, defaultValue, width}) => {
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState(defaultValue || '');

    return (
        <TextField
            required
            autoComplete='off'
            fullWidth
            variant="outlined"
            value={value}
            id={idName}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={(e) => {
                setValue(e.target.value);
                if (onChange) {
                    onChange(e);
                }
            }}
            multiline
            rows={numRows}
            maxRows={rowsMax}
            sx={{
                backgroundColor: globals.colors.backgroundColor,
                width: width || null,
                borderRadius: 1,
                color: globals.colors.textColor,
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: globals.colors.darkRed, // default border color
                    },
                    '&:hover fieldset': {
                        borderColor: globals.colors.darkRed, // border color on hover
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: globals.colors.darkRed, // border color when focused
                    },
                },
                mt: 2
            }} 
            helperText="Задължително поле"
        />
    );
};

export default EditCourseTF;